import { useMemo } from 'react';
import { Box } from '@mui/material';
import SideBarModal from '../modal/SideBarModal';
import FlashDesignDetailCard from './FlashDesignDetailCard';
import { Section, FooterAction } from '../../interfaces';
import { getRefImagesFromFlashDesign } from '../../helpers/flashbooks';
import useGetFlashbookDesign from '../../hooks/flashbooks/useGetFlashbookDesign';

interface Props {
  flashbookId: string | undefined;
  flashDesignId: number | undefined;
  isOpen: boolean;
  onClose: () => void;
  footerActions?: FooterAction[];
  moreActions?: FooterAction[];
}

export default function FlashDesignSidebarModal({
  flashbookId,
  flashDesignId,
  isOpen,
  onClose,
  footerActions,
  moreActions,
}: Props) {
  const { data: design, isLoading } = useGetFlashbookDesign({
    flashbookId,
    flashDesignId,
    enabled: isOpen,
  });

  const sections = useMemo<Section[]>(() => {
    if (!design) return [];
    const [coverImage] = getRefImagesFromFlashDesign(design);

    return [
      {
        name: '',
        noGap: true,
        rows: [
          ...(coverImage
            ? [
                {
                  id: 'flash-design-image',
                  label: '',
                  type: 'NODE' as const,
                  value: [
                    <Box
                      key="flash-design-image"
                      component="img"
                      src={coverImage}
                      alt={design.name}
                      sx={{
                        width: '100%',
                        aspectRatio: '1 / 1',
                        objectFit: 'cover',
                        backgroundColor: 'transparent',
                        display: 'block',
                      }}
                    />,
                  ],
                },
              ]
            : []),
          {
            id: 'flash-design-detail-card',
            label: '',
            type: 'NODE' as const,
            value: [
              <Box key="flash-detail-card" pt={2.5} pb={1}>
                <FlashDesignDetailCard design={design} />
              </Box>,
            ],
          },
        ],
      },
    ];
  }, [design]);

  return (
    <SideBarModal
      modalOpen={isOpen}
      setModalOpen={onClose}
      name={design?.name ?? 'Flash design'}
      sections={sections}
      isLoading={isLoading}
      footerActions={footerActions}
      moreActions={moreActions}
    />
  );
}
